
export function buildExternalUrl(url, params) {
  console.log('url---->', url);
  console.log('params---->', params);

  // 创建一个新的参数对象以避免修改原始对象
  const processedParams = {};

  // 遍历参数对象，替换 URL 中的大括号包裹的变量
  Object.keys(params).forEach(key => {
    const value = params[key];
    if (typeof value === 'string' && value.startsWith('{') && value.endsWith('}')) {
      // 去掉首尾的大括号
      const trimmedValue = value.slice(1, -1);
      const regex = new RegExp(`\\{${trimmedValue}\\}`, 'g');
      processedParams[key] = value.replace(regex, localStorage.getItem(trimmedValue));
    } else {
      processedParams[key] = value;
    }
  });

  console.log(processedParams); // 输出处理后的参数对象

  // 拼接参数到 URL 后面
  const paramString = Object.keys(processedParams)
    .map(key => `${key}=${processedParams[key]}`) // 不使用 encodeURIComponent
    .join('&');

  console.log(paramString); // 输出拼接后的参数字符串

  // 检查 URL 中是否已经有查询参数（?）
  const separator = url.includes('?') ? '&' : '?';

  // 返回拼接后的完整 URL
  return `${url}${paramString ? separator + paramString : ''}`;

}

//外部客服
export function openWechatService() {
  window.open('https://work.weixin.qq.com/kfid/kfc691deb58e08aa51f', '_blank')
}

//内部客服
export function openCustomerServicee() {
  window.open('https://work.weixin.qq.com/kfid/kfc9e1b4912fac45be5', '_blank')
}